import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

const API_LIST = '/p-crm-duration';
const API_DETAIL = (id: number) => `/p-crm-duration/${id}`;

export interface AppDuration {
  id: number;
  pd_descr?: string;
  pd_min?: number;
  pd_order?: number;
}

export const useAppDurations = (searchParams?: string) => {
  const params = new URLSearchParams({ manage: '1' });
  if (searchParams) params.set('searchParams', searchParams);
  const queryString = `?${params.toString()}`;
  const { data, error, isLoading, mutate } = useSWR<AppDuration[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    appDurations: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useAppDuration = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<AppDuration>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    appDuration: data,
    isLoading,
    isError: error,
    mutate,
  };
};
